export interface Volume {
  number: string
  label: string
  title: string
  tagline: string
  intro: string
  items: string[]
  closing: string
  accent: string
}

export const volumes: Volume[] = [
  {
    number: 'I',
    label: 'VOLUME I',
    title: 'THE RENAL NAVIGATOR™',
    tagline: 'Find the right route before you start searching.',
    intro:
      'The master navigation system that takes you from the initial renal finding to the appropriate decision pathway.',
    items: [
      'Abnormal creatinine pathway',
      'Reduced eGFR pathway',
      'Albuminuria pathway',
      'CKD identification framework',
      'G and A category navigation',
      'Initial assessment framework',
      'Risk and progression considerations',
      '“Start here” decision maps',
      'Clinical scenario index',
      'Master renal decision tree',
    ],
    closing:
      'Stop asking “Which resource should I open?” Start asking “Which route am I on?”',
    accent: '#1f4f8f',
  },
  {
    number: 'II',
    label: 'VOLUME II',
    title: 'THE RENAL DECISION ENGINE™',
    tagline: 'Turn renal information into structured treatment decisions.',
    intro:
      'A practical framework for organizing the clinical questions that arise around nephroprotective and commonly used therapies.',
    items: [
      'Medication decision pathways',
      'ACE inhibitor / ARB considerations',
      'SGLT2 inhibitor considerations',
      'Albuminuria pathways',
      'Creatinine-change scenarios',
      'Medication review framework',
      'Treatment reassessment pathways',
      'Monitoring considerations',
      'Follow-up decision routes',
    ],
    closing:
      'The goal isn’t to memorize medication rules. It’s to structure the decision before acting.',
    accent: '#0f7a6e',
  },
  {
    number: 'III',
    label: 'VOLUME III',
    title: 'THE RENAL LAB COMMAND CENTER™',
    tagline: 'Know how to navigate the abnormal renal laboratory result.',
    intro:
      'A visual decision system for common laboratory and metabolic scenarios associated with kidney disease.',
    items: [
      'Potassium decision pathway',
      'Acid-base assessment framework',
      'Diuretic considerations',
      'Fluid-management framework',
      'Electrolyte abnormality routes',
      'Laboratory reassessment pathways',
      'Warning-sign framework',
      'Monitoring routes',
      'Escalation considerations',
    ],
    closing: 'Abnormal result → Structured assessment → Next route',
    accent: '#1b6d4f',
  },
  {
    number: 'IV',
    label: 'VOLUME IV',
    title: 'THE CARDIO-RENAL DECISION MAP™',
    tagline: 'Organize the patient whose kidney disease doesn’t exist in isolation.',
    intro:
      'CKD frequently intersects with diabetes, hypertension, heart failure, cardiovascular risk, and multiple medications. This volume gives you a structured way to organize those competing clinical priorities.',
    items: [
      'CKD + diabetes framework',
      'CKD + hypertension framework',
      'CKD + heart failure framework',
      'Proteinuria considerations',
      'Cardiovascular risk framework',
      'Medication considerations',
      'Treatment-priority map',
      'Monitoring framework',
      'Follow-up pathways',
    ],
    closing:
      'Stop looking at one lab value at a time. Start looking at the whole clinical route.',
    accent: '#8c1c2b',
  },
  {
    number: 'V',
    label: 'VOLUME V',
    title: 'THE MONITOR & REFER MATRIX™',
    tagline:
      'Know what to monitor, when to reassess, and when specialist evaluation should be considered.',
    intro: 'A practical navigation system for ongoing CKD management.',
    items: [
      'Monitoring framework',
      'Disease-progression considerations',
      'Anemia pathway',
      'Calcium/phosphate considerations',
      'Vitamin D considerations',
      'Metabolic-acidosis pathway',
      'Follow-up planning',
      'Referral considerations',
      'Referral-preparation checklist',
      '“Manage / Monitor / Escalate” framework',
    ],
    closing:
      'Turn follow-up from an open-ended question into a structured process.',
    accent: '#a35a10',
  },
  {
    number: 'VI',
    label: 'VOLUME VI',
    title: 'THE POINT-OF-CARE TOOLKIT™',
    tagline: 'Turn the entire system into tools you can actually use during the consultation.',
    intro: 'Your rapid-reference clinical toolkit includes:',
    items: [
      'Renal decision cards',
      'Consultation checklists',
      'Medication review sheets',
      'Monitoring templates',
      'Follow-up planners',
      'Referral checklists',
      'Clinical documentation prompts',
      'Quick-reference tables',
      'Patient conversation frameworks',
      'Master consultation worksheet',
      'Mobile reference pages',
      'Printable desk tools',
    ],
    closing: 'Find the scenario. Open the route. Navigate the decision.',
    accent: '#5b3a8e',
  },
]
